import type { BrandHealthOverview } from '@/types/brandHealth';
type ChannelRows = BrandHealthOverview['volume']['channels'];
export const CHANNEL_GROUPS = ['email', 'social', 'chat', 'sms', 'unknown'] as const;
export function channelGroup(channel: string): string {
  const value = channel.trim().toLowerCase().replaceAll('_', '-');
  if (['email', 'chat', 'sms'].includes(value)) return value;
  if (value === 'social' || /^(facebook|instagram|twitter|whatsapp|tiktok|messenger)(-|$)/.test(value)) return 'social';
  return 'unknown';
}
export function groupChannels(rows: ChannelRows): ChannelRows {
  return CHANNEL_GROUPS.flatMap((group) => {
    const matches = rows.filter((row) => channelGroup(row.channel) === group);
    return matches.length ? [{ channel: group[0].toUpperCase() + group.slice(1), count: matches.reduce((sum, row) => sum + row.count, 0), share: matches.reduce((sum, row) => sum + row.share, 0) }] : [];
  });
}
export function expandChannels(selected: string[], available: string[]): string[] {
  if (!selected.length) return [];
  const expanded = available.filter((channel) => selected.includes(channelGroup(channel)));
  return [...new Set([...expanded, ...selected.filter((group) => !expanded.some((channel) => channelGroup(channel) === group) || group === 'unknown')])];
}
